export default __webpack_public_path__ + "static/icon-360-7604389d25536f14ba680ac7ff560ace.png";